import * as React from 'react';
import { connect } from 'react-redux';
import {
    setFiltroPublicacion,
    fetchPublicaciones,
    fetchVariaciones,
    fetchMarcas,
    fetchCategorias
} from '../../../actions/publicacionesActions';
import { fetchExportarPublicacionesApi } from '../../../api/axios';
import { fetchSellers } from '../../../actions/sellersActions';
import { fetchTiposPublicacionAdm } from '../../../actions/tiposPublicacionActions';
import PublicacionesFilter from '../../Publicaciones/Components/PublicacionesFilter';
import BigSpinner from "../../General/BigSpinner";
import MiniSpinner from "../../General/MiniSpinner";
import { filtroMedioMes } from '../../../utilities/fechasFiltro';
import { toast } from 'react-toastify';
import ReactExport from "react-export-excel";
const fechaFiltro = filtroMedioMes();
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;


class ExportarPublicaciones extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            filterOptions: { idSeller: null },
            datosExcelFormateados: null,
            listaTipoPublicacionCargada: false,
            hideSpinner: true
        }
    }

    componentDidMount() {
        this.props.publicaciones.cantidadTotal = 0;
        this.cargarTipoPublicacionLista();
        this.props.fetchVariaciones();
        this.onFetchFilterOptions();
    }

    onFetchFilterOptions = (descripcion) => {
        this.props.fetchCategorias(descripcion);
        this.props.fetchMarcas(descripcion);
        this.props.fetchSellers({ descripcion });
    }

    setInitialPage = () => { }

    busquedaPublicaciones = () => {
        let idSeller = this.props.idSeller;

        if (this.props.userType.isCategory || this.props.userType.isAdminMod) {
            if (this.props.filtroPublicacion.idSeller !== null) {
                idSeller = this.props.filtroPublicacion.idSeller;
            } else {
                idSeller = null;
            }
        }

        let filtroPublicacion = this.props.filtroPublicacion;

        if (filtroPublicacion.fechaPublicacionHasta === undefined) {
            filtroPublicacion.fechaPublicacionHasta = fechaFiltro.hasta
        }

        if (filtroPublicacion.fechaPublicacionDesde === undefined) {
            filtroPublicacion.fechaPublicacionDesde = fechaFiltro.desde
        }

        this.setState({ filterOptions: filtroPublicacion });
        this.props.fetchPublicaciones({
            idSeller: idSeller,
            categoria: filtroPublicacion.categoria,
            marca: filtroPublicacion.marca,
            estado: filtroPublicacion.estado,
            skuSeller: filtroPublicacion.skuSeller,
            skuMarket: filtroPublicacion.skuMarket,
            fechaPublicacionDesde: filtroPublicacion.fechaPublicacionDesde,
            fechaPublicacionHasta: filtroPublicacion.fechaPublicacionHasta,
            idTipoPublicacion: filtroPublicacion.idTipoPublicacion,
            sinStock: filtroPublicacion.sinStock,
            NumeroPagina: 1
        });
    }

    chargeFilterOptions = (options) => {
        this.setState({ datosExcelFormateados: null });
        this.props.setFiltroPublicacion(options);
        this.setState({ filterOptions: options });
    }

    cargarTipoPublicacionLista = () => {
        let listaTipoPublicacion = { params: { "CantidadPagina": 100 } };
        if (!this.state.listaTipoPublicacionCargada) {
            if (this.props.userType.isCategory || this.props.userType.isAdminMod) {
                this.props.fetchTiposPublicacionAdm(listaTipoPublicacion);
            } else {
                this.props.fetchTiposPublicacionAdm(this.props.idSeller);
            }
        }
        this.setState({ listaTipoPublicacionCargada: true });
    }

    busquedaParaDescargarExcel = () => {

        this.setState({ datosExcelFormateados: null });
        this.setState({ hideSpinner: false });

        let idSeller = this.props.idSeller;

        if (this.props.userType.isCategory || this.props.userType.isAdminMod) {
            // eslint-disable-next-line 
            if (this.props.filtroPublicacion.idSeller != "") {
                idSeller = parseInt(this.props.filtroPublicacion.idSeller);
            } else {
                idSeller = null;
            }
        }

        let filtroPublicacion = this.props.filtroPublicacion;

        this.requestParaExportar({
            idSeller: idSeller,
            fechaPublicacionDesde: filtroPublicacion.fechaPubDesde,
            fechaPublicacionHasta: filtroPublicacion.fechaPubHasta,
            categoria: filtroPublicacion.categoria == "" ? null : parseInt(filtroPublicacion.categoria),
            marca: filtroPublicacion.marca == "" ? null : parseInt(filtroPublicacion.marca),
            estado: filtroPublicacion.estado,
            skuSeller: filtroPublicacion.skuSeller,
            skuMarket: filtroPublicacion.skuMarket,
            sinStock: filtroPublicacion.sinStock == "" ? null : filtroPublicacion.sinStock
        });
    }

    requestParaExportar = async (request) => {
        let req = null;
        try {
            req = await fetchExportarPublicacionesApi(request);
        } catch (e) {
            toast.error('No se pudo descargar el excel');
        }

        this.ordenarExcel(req.publicaciones);
    }

    ordenarExcel = (publicaciones) => {

        let listaPublicaciones = [];

        publicaciones.map((item => {

            let datoPublicacion = {
                nombreSeller: item.seller != null ? item.seller : "",
                idPublicacion: item.idPublicacion,
                skuPlataforma: item.skuMarket,
                skuSeller: item.skuSeller,
                nombreProducto: item.titulo,
                ean: item.ean,
                categoria: item.categoria != null ? item.categoria : "",
                marca: item.marca != null ? item.marca : "",
                stock: item.stock,
                precioLista: item.precioLista,
                precioOferta: item.precioPromocional,
                tipoPublicacion: item.tipoPublicacion != null ? item.tipoPublicacion.descripcion : "",
                comision: item.tipoPublicacion != null ? item.tipoPublicacion.comision : "",
                tipoEntrega: item.tipoEntrega[0].descripcion,
                costoEnvio: item.envioGratis === true ? "Con envío gratis" : "Sin envío",
                estado: item.estado,
                alto: item.dimensiones[0]?.alto ?? null,
                ancho: item.dimensiones[0]?.ancho ?? null,
                profundidad: item.dimensiones[0]?.profundidad ?? null,
                peso: item.dimensiones[0]?.peso ?? null,
                alto2: item.dimensiones[1]?.alto ?? null,
                ancho2: item.dimensiones[1]?.ancho ?? null,
                profundidad2: item.dimensiones[1]?.profundidad ?? null,
                peso2: item.dimensiones[1]?.peso ?? null,
                alto3: item.dimensiones[2]?.alto ?? null,
                ancho3: item.dimensiones[2]?.ancho ?? null,
                profundidad3: item.dimensiones[2]?.profundidad ?? null,
                peso3: item.dimensiones[2]?.peso ?? null,
                alto4: item.dimensiones[3]?.alto ?? null,
                ancho4: item.dimensiones[3]?.ancho ?? null,
                profundidad4: item.dimensiones[3]?.profundidad ?? null,
                peso4: item.dimensiones[3]?.peso ?? null,
                alto5: item.dimensiones[4]?.alto ?? null,
                ancho5: item.dimensiones[4]?.ancho ?? null,
                profundidad5: item.dimensiones[4]?.profundidad ?? null,
                peso5: item.dimensiones[4]?.peso ?? null
            };

            listaPublicaciones.push(datoPublicacion);
        }))

        this.setState({
            datosExcelFormateados: listaPublicaciones,
            hideSpinner: true,
        })

        document.getElementById("btnDescargaExcel").click();
    }


    render() {
        let sizeArray = JSON.stringify(this.state.datosExcelFormateados);

        return (
            <section className="container" role="search">
                <div className="row page-titles">
                    <div className="col-12">
                        <div className="row justify-content-between align-items-center">

                            <div className="col-12 col-md-auto">
                                <h4 className="text-themecolor color-rojo-megatone">Publicaciones</h4>
                            </div>

                            <div className="col-12 col-md-auto">
                                <div className="row justify-content-center">
                                    <div className="col-auto button-group text-right d-block">
                                        {this.state.hideSpinner || sizeArray != "[]" && <MiniSpinner />}
                                    </div>

                                    <div className="col-12 col-md-auto button-group text-right">
                                        <button
                                            type="button"
                                            onClick={this.busquedaParaDescargarExcel}
                                            className="btn btn-sm btn-green"
                                            disabled={this.props.loadingPublicaciones || this.props.cantidadTotal === 0}
                                        >
                                            Descargar {this.props.cantidadTotal} publicaciones
                                        </button>

                                        <ExcelFile
                                            filename="Publicaciones"
                                            element={<button id="btnDescargaExcel" type="button" hidden={true} />}
                                        >
                                            <ExcelSheet data={this.state.datosExcelFormateados} name="Publicaciones">
                                                <ExcelColumn label="Nombre Seller" value="nombreSeller" />
                                                <ExcelColumn label="SKU Plataforma" value="skuPlataforma" />
                                                <ExcelColumn label="SKU Seller" value="skuSeller" />
                                                <ExcelColumn label="Nombre Producto" value="nombreProducto" />
                                                <ExcelColumn label="EAN" value="ean" />
                                                <ExcelColumn label="Categoría" value="categoria" />
                                                <ExcelColumn label="Marca" value="marca" />
                                                <ExcelColumn label="Stock" value="stock" />
                                                <ExcelColumn label="Precio Lista" value="precioLista" />
                                                <ExcelColumn label="Precio Oferta" value="precioOferta" />
                                                <ExcelColumn label="Tipo de Publicación" value="tipoPublicacion" />
                                                <ExcelColumn label="Comisión" value="comision" />
                                                <ExcelColumn label="Tipo de Entrega" value="tipoEntrega" />
                                                <ExcelColumn label="Costo de Envio" value="costoEnvio" />
                                                <ExcelColumn label="Estado" value="estado" />
                                                <ExcelColumn label="Alto" value="alto" />
                                                <ExcelColumn label="Ancho" value="ancho" />
                                                <ExcelColumn label="Profundidad" value="profundidad" />
                                                <ExcelColumn label="Peso" value="peso" />
                                                <ExcelColumn label="Alto" value="alto2" />
                                                <ExcelColumn label="Ancho" value="ancho2" />
                                                <ExcelColumn label="Profundidad" value="profundidad2" />
                                                <ExcelColumn label="Peso" value="peso2" />
                                                <ExcelColumn label="Alto" value="alto3" />
                                                <ExcelColumn label="Ancho" value="ancho3" />
                                                <ExcelColumn label="Profundidad" value="profundidad3" />
                                                <ExcelColumn label="Peso" value="peso3" />
                                                <ExcelColumn label="Alto" value="alto4" />
                                                <ExcelColumn label="Ancho" value="ancho4" />
                                                <ExcelColumn label="Profundidad" value="profundidad4" />
                                                <ExcelColumn label="Peso" value="peso4" />
                                                <ExcelColumn label="Alto" value="alto5" />
                                                <ExcelColumn label="Ancho" value="ancho5" />
                                                <ExcelColumn label="Profundidad" value="profundidad5" />
                                                <ExcelColumn label="Peso" value="peso5" />
                                            </ExcelSheet>
                                        </ExcelFile>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <PublicacionesFilter
                    filtro={this.props.emptyFiltro.publicaciones == false ? this.props.filtroPublicacion : ""}
                    setInitialPage={this.setInitialPage}
                    chargeFilterOptions={this.chargeFilterOptions}
                    allowSearchBySeller={this.props.userType.isCategory || this.props.userType.isAdminMod}
                />

                {this.props.loadingPublicaciones && <BigSpinner />}

            </section>
        );
    }
}


const mapStateToProps = state => ({
    userType: state.general.userType,
    idSeller: state.general.idSeller,
    publicaciones: state.publicaciones.publicaciones,
    filtroPublicacion: state.publicaciones.filtroPublicaciones,
    cantidadTotal: state.publicaciones.publicaciones.cantidadTotal,
    loadingPublicaciones: state.publicaciones.loadingPublicaciones,
    emptyFiltro: state.general.limpiar
});

export default connect(mapStateToProps, {
    setFiltroPublicacion,
    fetchTiposPublicacionAdm,
    fetchPublicaciones,
    fetchCategorias,
    fetchVariaciones,
    fetchMarcas,
    fetchSellers,
})(ExportarPublicaciones);